import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-top" maskId="round-filled-radius-1-stroke-1.5-IconArrowTriangleTop"><path d="M4.18721 17.4654C3.61264 18.6123 4.42612 20 5.73462 20H18.2651C19.5736 20 20.3871 18.6123 19.8125 17.4654L13.5473 4.95962C12.9062 3.68013 11.0935 3.68013 10.4524 4.95962L4.18721 17.4654Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
